import type { QueryClient } from '@tanstack/react-query';
import { type RealtimeRefetchOutcome, refetchRealtimeQuery } from './refetchRealtimeQuery.js';

/** Reconcile the canonical proposal entity after an on-chain backing or withdrawal.
 * Inactive entities stay stale for their next mount; an active detail query
 * refetches through its data-owning SDK observer. */
export async function reconcileProposalEntity(
  queryClient: QueryClient,
  proposalPubkey: string,
): Promise<RealtimeRefetchOutcome> {
  const queryKey = ['proposals', 'entity', proposalPubkey] as const;
  await queryClient.invalidateQueries({ queryKey, exact: true, refetchType: 'none' }); // ALLOW-STATE-OWNERSHIP: exact canonical proposal entity reconcile
  return refetchRealtimeQuery(queryClient, queryKey);
}
